import { axiosConfig } from './axios-config.js'

export const inquiry = {
  // 取得門市諮詢單
  getStore: (id, token) => axiosConfig.get(`/api/console/inquiry/store/${id || ''}`, token),

  // 更新門市諮詢單
  updateStore: (id, data, token) => axiosConfig.patch(`/api/console/inquiry/store/${id}`, data, token),

  // 取得門市諮詢單
  getProduct: (id, token) => axiosConfig.get(`/api/console/inquiry/product/${id || ''}`, token),

  // 更新門市諮詢單
  updateProduct: (id, data, token) => axiosConfig.patch(`/api/console/inquiry/product/${id}`, data, token),

  // 取得行程諮詢單
  getItinerary: (id, token) => axiosConfig.get(`/api/console/inquiry/itinerary/${id || ''}`, token),

  // 更新行程諮詢單
  updateItinerary: (id, data, token) => axiosConfig.patch(`/api/console/inquiry/itinerary/${id}`, data, token)
}
